import React from "react";
import PropTypes from "prop-types";
import Modal from "@mui/material/Modal";
import Button from "@mui/material/Button";
import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import "../organisation/organization.css";
import {
  fontFamily,
  reviewScreenButtonWithColor,
  reviewScreenButtonWithOutColor,
} from "../Constants/constants";

export default function OrganisationModel({ show, handleClose, onSave, editingData }) {
  const [name, setName] = React.useState("");
  const [description, setDescription] = React.useState("");
  const [nameError, setNameError] = React.useState("");
  const [descriptionError, setDescriptionError] = React.useState("");

  // New organization settings fields
  const [storageType, setStorageType] = React.useState("BLOB"); // Default to BLOB
  const [autoSuspendUserAfterDays, setAutoSuspendUserAfterDays] = React.useState(10);

  React.useEffect(() => {
    if (editingData) {
      console.log("editingData in model", editingData);
      setDescription(editingData.description);
      setName(editingData.name);
      setStorageType(editingData.storageType || "BLOB"); // Default to BLOB
      setAutoSuspendUserAfterDays(editingData.autoSuspendUserAfterDays || 10);
    } else {
      setDescription("");
      setName("");
      setStorageType("BLOB"); // Default to BLOB
      setAutoSuspendUserAfterDays(10);
    }
    // Clear errors when modal opens
    setNameError("");
    setDescriptionError("");
  }, [editingData, show]);

  const validateForm = () => {
    let isValid = true;

    // Validate name
    if (!name || name.trim() === "") {
      setNameError("Name is required");
      isValid = false;
    } else if (name.trim().length < 2) {
      setNameError("Name must be at least 2 characters long");
      isValid = false;
    } else {
      setNameError("");
    }

    // Validate description
    if (!description || description.trim() === "") {
      setDescriptionError("Description is required");
      isValid = false;
    } else if (description.trim().length < 5) {
      setDescriptionError("Description must be at least 5 characters long");
      isValid = false;
    } else {
      setDescriptionError("");
    }

    return isValid;
  };

  const handleSaveClick = () => {
    if (validateForm()) {
      // Get user info from localStorage
      const userData = JSON.parse(localStorage.getItem("token")) || {};
      const userEmail = userData.email || "";

      const newRow = {
        name: name.trim(),
        description: description.trim(),
        createdBy: userEmail,
        storageType: storageType || "BLOB", // Default to BLOB
        pythonAPI: "", // Keep empty as requested
        autoSuspendUserAfterDays: parseInt(autoSuspendUserAfterDays) || 90,
      };
      onSave(newRow);
    }
  };

  const handleNameChange = (e) => {
    setName(e.target.value);
    if (nameError) {
      setNameError("");
    }
  };

  const handleDescriptionChange = (e) => {
    setDescription(e.target.value);
    if (descriptionError) {
      setDescriptionError("");
    }
  };



  return (
    <Modal
      open={show}
      onClose={handleClose}
      aria-labelledby="add-administrator-modal-title"
      aria-describedby="add-administrator-modal-description"
    >
      <div
        style={{
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          position: "absolute",
          outline: "none",
          width: "450px", // Width changed to 500px
          padding: "20px",
          backgroundColor: "white",
          boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
          borderRadius: "8px",
        }}
      >
        <h6 style={{ color: "#2aa7e0", fontFamily: fontFamily }}>
          {editingData ? "Edit Organization" : "Add New Organization"}
        </h6>
        <div
          style={{
            height: "1px",
            width: "410px",
            backgroundColor: "#2aa7e0",
            marginBottom: "20px",
            marginRight: "10px",
          }}
        ></div>

        <div>
          {/* Adjusting height of text boxes */}
          <div style={{ marginBottom: "20px", display: "flex", flexDirection: "row" }}>
            <span
              style={{
                color: "black",
                display: "inline-block",
                width: "105px",
                fontFamily: fontFamily,
              }}
            >
              Name <span style={{ color: "red" }}>*</span>
            </span>
            <div style={{ display: "flex", flexDirection: "column", flex: 1 }}>
              <input
                type="text"
                value={name}
                onChange={handleNameChange}
                className={nameError ? "text-input text-input-error" : "text-input"}
              />
              {nameError && (
                <span
                  style={{
                    color: "#d32f2f",
                    fontSize: "12px",
                    marginTop: "4px",
                    marginLeft: "20px",
                  }}
                >
                  {nameError}
                </span>
              )}
            </div>
          </div>
          <div style={{ marginBottom: "20px", display: "flex", flexDirection: "row" }}>
            <span
              style={{
                color: "black",
                display: "inline-block",
                width: "105px",
                fontFamily: fontFamily,
              }}
            >
              Description <span style={{ color: "red" }}>*</span>
            </span>
            <div style={{ display: "flex", flexDirection: "column", flex: 1 }}>
              <input
                type="text"
                value={description}
                onChange={handleDescriptionChange}
                className={descriptionError ? "text-input text-input-error" : "text-input"}
              />
              {descriptionError && (
                <span
                  style={{
                    color: "#d32f2f",
                    fontSize: "12px",
                    marginTop: "4px",
                    marginLeft: "20px",
                  }}
                >
                  {descriptionError}
                </span>
              )}
            </div>
          </div>

          <div
            style={{
              marginBottom: "20px",
              display: "flex",
              flexDirection: "row",
              alignItems: "center",
            }}
          >
            <span
              style={{
                color: "black",
                display: "inline-block",
                width: "105px",
                fontFamily: fontFamily,
              }}
            >
              Storage Type <span style={{ color: "red" }}>*</span>
            </span>
            <RadioGroup
              value={storageType}
              onChange={(e) => setStorageType(e.target.value)}
              row
              style={{ flex: 1 }}
            >
              <FormControlLabel
                value="BLOB"
                control={<Radio style={{ color: "#2aa7e0" }} />}
                label="BLOB Storage"
              />
              <FormControlLabel
                value="SQL"
                control={<Radio style={{ color: "#2aa7e0" }} />}
                label="SQL Database"
              />
            </RadioGroup>
          </div>

          <div style={{ marginBottom: "20px", display: "flex", flexDirection: "row" }}>
            <span
              style={{
                color: "black",
                display: "inline-block",
                width: "105px",
                fontFamily: fontFamily,
              }}
            >
              Auto Suspend User After Days
            </span>
            <input
              type="number"
              value={autoSuspendUserAfterDays}
              onChange={(e) => setAutoSuspendUserAfterDays(e.target.value)}
              className="text-input"
            />
          </div>

          <div style={{ display: "flex", justifyContent: "flex-end", gap: "10px" }}>
            {/* Adjusting button styles as per requirements */}
            <Button
              variant="contained"
              style={reviewScreenButtonWithOutColor(100)}
              onClick={handleClose}
            >
              Cancel
            </Button>
            <Button
              variant="contained"
              style={reviewScreenButtonWithColor(80)}
              onClick={handleSaveClick}
            >
              Save
            </Button>
          </div>
        </div>
      </div>
    </Modal>
  );
}

OrganisationModel.propTypes = {
  show: PropTypes.bool.isRequired,
  handleClose: PropTypes.func.isRequired,
  onSave: PropTypes.func.isRequired,
  editingData: PropTypes.func.isRequired,
};
